import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-05/lesson-22/task-02";

const task: Slide = {
  titleHtml:
    "If the measured single number value for sound reduction index R’w(C,Ctr) with<br>spectral adaptation terms for two facades is given as R’w1(C,Ctr)=50(-1,-1) and<br>R’w2=52(-1,-3) and the sound pressure level from traffic in front of the facade is the<br>same (75 dBA) the correct statement for the sound pressure level (SPL) in the<br>receiving room is: ",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
